import React from "react";
import defaultLocale from "./default";

export default {
  ...defaultLocale,
  lotNumber: "Lot Number",
  landingPageText: () => {
    return (
      <div>
        There are two easy steps to have your vehicle picked up!
        <ol className="lp-o-list">
          <li>Confirm your vehicle and personal information</li>
          <li>
            Confirm the vehicle is prepared
            <ul>
              <li>Ensure the keys are available</li>
              <li>Make sure it’s accessible</li>
              <li>Remove your personal items</li>
            </ul>
          </li>
        </ol>
      </div>
    );
  },
  policyHolder: "Will someone be with the vehicle for collection ?",
};



// WEBPACK FOOTER //
// ./src/locale/sellerLocaleUk/TRD.js